function jcRefreshCollectionView(url) {
  fetch(url.toJSON())
      .then((response) => response.text())
      .then((html) => {
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = html;

          document.querySelector('.jc-product-list__grid').innerHTML = tempDiv.querySelector('.jc-product-list__grid').innerHTML;

          document.querySelector('.jc-product-list-head__count').innerHTML = tempDiv.querySelector('.jc-product-list-head__count').innerHTML;

          document.querySelectorAll('.jc-filter__checkbox').forEach((checkbox) => {
              const updated = tempDiv.querySelector(`.jc-filter__checkbox[name="${checkbox.name}"][value="${checkbox.value}"]`);
              if (!updated) return;

              checkbox.checked = updated.checked;
              checkbox.dataset.addUrl = updated.dataset.addUrl;
              checkbox.dataset.removeUrl = updated.dataset.removeUrl;
          });

          url.searchParams.delete('section_id');
          window.history.pushState({}, '', url.toString());
      });
}

if (!customElements.get('jc-filters')) {
  customElements.define(
    'jc-filters',
    class JCFilters extends HTMLElement {
      constructor() {
        super();
      }

      get sectionId() {
        return this.dataset.sectionId;
      }

      connectedCallback() {
        this.filterInputs = this.querySelectorAll('input');
        this.handleClick = this.handleClick.bind(this);
        this.minPriceInput = this.querySelector('input[type="text"][data-min-value]');
        this.maxPriceInput = this.querySelector('input[type="text"][data-max-value]');

        this.filterInputs.forEach((input) => {
          input.addEventListener('change', this.handleClick);
          input.addEventListener('input', this.handleClick);
        });
      }

      handleClick() {
        const input = event.currentTarget;
        let url;

        if(input.dataset.addUrl || input.dataset.removeUrl) {
          url = new URL(input.checked ? input.dataset.addUrl : input.dataset.removeUrl, window.location.origin);
        }
        else {
          url = new URL(window.location.href);

          url.searchParams.delete(this.minPriceInput.dataset.param);
          url.searchParams.delete(this.maxPriceInput.dataset.param);

          if(this.minPriceInput.value) {
            url.searchParams.set(this.minPriceInput.dataset.param, this.minPriceInput.value);
          }
          if(this.maxPriceInput.value) {
            url.searchParams.set(this.maxPriceInput.dataset.param, this.maxPriceInput.value);
          }
        }

        jcRefreshCollectionView(url);
      }
    }
  );
}

if (!customElements.get('jc-product-sort')) {
  customElements.define(
    'jc-product-sort',
    class JCProductSort extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.select = this.querySelector('select[name="sort_by"]');
        this.handleChange = this.handleChange.bind(this);

        this.select.addEventListener('change', this.handleChange);
      }

      handleChange() {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', this.select.value);

        jcRefreshCollectionView(url);
      }
    }
  );
}
